export default __webpack_public_path__ + "static/media/SIFA_NL_EPILOG03.dfd8d06d.mp3";